import { toast } from "react-toastify";
import Button from "../../../Components/Button";
import { cancelStepBrokerOrder } from "../../../Requests/stepRequests";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import { TableCell } from "@mui/material";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { useState } from "react";
import Loading from "../../../Components/Loading/Loading";
import { IManualSahraOrderTableReport } from "../../../Interfaces/manualInterfaces";
import { cancelManualOrder, cancelSahraOrder } from "../../../Requests/manualRequests";

const ManualSahraOrderesTableAdditionalHeader: React.FC = ({}) => {
  return (
    <TableCell>
      <span className="!font-black text-black">عملیات</span>
    </TableCell>
  );
};

const ManualSahraOrderesAdditionalCol: React.FC<{
  row: IManualSahraOrderTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [loading, setLoading] = useState(false);

  const cancelHandler = () => {
    setLoading(true);
    cancelSahraOrder(row.id)
      .then((resp) => {
        toast.success(resp.msg);
        onAction();
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <TableCell>
      {row.isActive ? (
        <Button
          text={
            loading ? (
              <Loading size={16} className="!text-white" />
            ) : (
              "کنسل کردن"
            )
          }
          variant="contained"
          onClick={cancelHandler}
          className="table-btn"
        />
      ) : null}
    </TableCell>
  );
};

export const ManualSahraOrdersTableAdditional: IAdditional<IManualSahraOrderTableReport> =
  {
    getHeader: ManualSahraOrderesTableAdditionalHeader,
    getRow: ManualSahraOrderesAdditionalCol,
  };
